import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";

export const Footer = () => (
  <footer data-testid="footer" className="bg-[var(--ink)] text-[var(--paper)] px-4 sm:px-8 pt-20 pb-10 overflow-hidden">
    <div className="max-w-7xl mx-auto">
      <div className="grid md:grid-cols-3 gap-10">
        <div className="md:col-span-2">
          <LogoMark className="w-28 h-28 sm:w-36 sm:h-36" />
          <p className="font-display font-extrabold text-3xl sm:text-4xl mt-6 max-w-lg leading-tight">
            Fun designs. Unique prints. <span className="text-[var(--yellow)]">Made with creativity.</span>
          </p>
        </div>
        <div className="space-y-4 text-[#d6d1e6]">
          <p className="font-mono-x text-xs uppercase tracking-[0.2em] text-[var(--lime)] font-bold">Payments</p>
          <p>We accept bank transfer. Your order reference and our bank details are shown after checkout.</p>
          <p className="font-mono-x text-xs uppercase tracking-[0.2em] text-[var(--lime)] font-bold pt-2">Contact</p>
          <a href="mailto:scratchs3dprintz@gmail.com" data-testid="footer-contact" className="underline decoration-[var(--pink)] underline-offset-4 hover:text-[var(--yellow)] transition-colors break-all">scratchs3dprintz@gmail.com</a>
        </div>
      </div>
      <p className="font-display font-extrabold tracking-tighter leading-none text-[12.5vw] xl:text-[11rem] mt-16 rainbow-text select-none" aria-hidden="true">
        Scratchs3dprintz
      </p>
      <p className="mt-6 text-sm text-[#b9b3cc]">© {new Date().getFullYear()} Scratchs3dprintz. All prices in NZD. <Link to="/about" data-testid="footer-about-link" className="underline ml-2 hover:text-white transition-colors">About us</Link> <Link to="/info" data-testid="footer-info-link" className="underline ml-2 hover:text-white transition-colors">Returns & care</Link> <Link to="/admin" data-testid="footer-owner-link" className="underline ml-2 hover:text-white transition-colors">Owner login</Link></p>
    </div>
  </footer>
);
